import React from 'react'

const LanguageBoxes = () => {
  return (
    <>
    <div className='language-box-container'>
    <div className='item'>
        <div className='card' id="php-box">
            <h3>PHP</h3>
            <p>A web server programming language</p>
            <button className='btns'>Learn PHP</button>
        </div>
        <div className='card' id="jquery-box">
            <h3>jQuery</h3>
            <p>A JS library for developing web pages</p>
            <button className='btns'>Learn jQuery</button>
        </div>
        <div className='card' id="java-box">
            <h3>Java</h3>
            <p>A programming language</p>
            <button className='btns'>Learn Java</button>
        </div>
        <div className='card' id="cc-box">
            <h3>C++</h3>
            <p>A programming language</p>
            <button className='btns'>Learn C++</button>
        </div>
        <div className='card' id="w3-box">
            <h3>W3.CSS</h3>
            <p>A css framework for faster and better responsive web pages</p>
            <button className='btns'>Learn W3.CSS</button>
    </div>
        <div className='card'id="bootstrap">
            <h3>Bootstrap</h3>
            <p>A css framework for desiging better web pages</p>
            <button className='btns'>Learn Bootstrap</button>
    </div>
             <div className='card'id="c">
             <h3>C</h3>
     </div>
             <div className='card'id="C">
             <h3>C#</h3>
     </div>

<div className='grid-box-container'>
   <div className='container'>
    <div className='grid'>
        <div className='grid-item' id='r'>R</div>
        <div className='grid-item' id='koltin'>Koltin</div>
        <div className='grid-item' id='nodejs'>Node.js</div>
        <div className='grid-item' id='react'>React</div>

        <div className='grid-item' id='json'>JSON</div>
        <div className='grid-item' id='r'>Vue</div>
        <div className='grid-item' id='koltin'>MySQL</div>
        <div className='grid-item' id='nodejs'>XML</div>

        <div className='grid-item' id='react'>Sass</div>
        <div className='grid-item' id='json'>Icons</div>
        <div className='grid-item' id='r'>RWD</div>
        <div className='grid-item' id='nodejs'>Graphics</div>

        <div className='grid-item' id='nodejs'>SVG</div>
        <div className='grid-item' id='react'>Canvas</div>
        <div className='grid-item' id='json'>Raspberry Pi</div>
        <div className='grid-item' id='r'>Cyber Security</div>      

        <div className='grid-item' id='koltin'>Colors</div>
        <div className='grid-item' id='nodejs'>Git</div>
        <div className='grid-item' id='react'>Matplotlib</div>
        <div className='grid-item' id='json'>NumPy</div>      
          
        <div className='grid-item' id='r'>Pandas</div>
        <div className='grid-item' id='koltin'>SciPy</div>
        <div className='grid-item' id='nodejs'>ASP</div>
        <div className='grid-item' id='react'>AngularJS</div> 

        <div className='grid-item' id='json'>AppML</div>
        <div className='grid-item' id='r'>Go</div>
        <div className='grid-item' id='koltin'>TypeScript</div>
        <div className='grid-item' id='nodejs'>Django</div> 

        <div className='grid-item' id='react'>MangoDB</div>
        <div className='grid-item' id='json'>Statistics</div>
        <div className='grid-item' id='r'>Data Science</div>
        <div className='grid-item' id='r'>PostgreSQL</div> 

        <div className='grid-item' id='nodejs'>How To</div>
        <div className='grid-item' id='react'>Rust</div>
        <div className='grid-item' id='json'>Spaces</div>
        <div className='grid-item' id='koltin'>Typing Speed</div> 
    </div>
    </div>
   <div className='courses-offer-container'>
           <div className='course-container'>
            <div className='course-item' id='excel'>Excel</div>
            <div className='course-item' id='DSA'>DSA-Data Structures and Algorithms</div>
            <div className='course-item' id='ML'>Machine Learning</div>
            <div className='course-item' id='AI'>Artificial Intelligence</div>
            <div className='course-item' id='INTRO'>Introduction to programming</div>
            <div className='course-item' id='bash'>Bash</div>
           </div>
           </div>
   </div>
   </div>
   </div>
    </>
  );
}

export default LanguageBoxes;                                